import React from 'react';


import { useActions, useAppState } from 'state';
import { ClientFragment } from 'state/gql/_types';

import { extractCurrentItemData } from "utils/forms";
import FormDrawer from 'components/forms/FormDrawer';

import { DrawerActionProps } from 'components/layout/page/PageDrawerAction';

import FormSchema from 'components/tenant/order/schemas/verify_client_insurance.json';
import Icons from 'components/ui/Icons';
import OrderProcessAction from '../components/OrderProcessAction';
import { OrderActionProps } from './_types';

type FormPayloadType = Pick<ClientFragment,
    | 'insurance_name'
    | 'insurance_number'
    | 'insurance_start_date'
    | 'insurance_end_date'
    | 'insurance_image'
>

const initialState: FormPayloadType = {
    insurance_name: '',
    insurance_number: '',
    insurance_start_date: '',
    insurance_end_date: '',
    insurance_image: ''
};

const VerifyInsuranceDrawer: React.FC<DrawerActionProps<ClientFragment>> = ({ currentItem, onClose }) => {

    const { updateItem } = useActions().clients;
    const { loading, errors } = useAppState().orders;

    let currentItemId = null;
    let currentItemData = null;
    if (currentItem) {
        currentItemId = currentItem.id;
        currentItemData = extractCurrentItemData<FormPayloadType>(initialState, currentItem);
    }

    return (
        <>
            <FormDrawer<FormPayloadType, ClientFragment, string>
                autoOpen={false}
                formSchema={FormSchema}
                updateAction={updateItem}
                isLoading={loading}
                errors={errors}
                currentItemId={currentItemId}
                initialData={initialState}
                currentItemData={currentItemData}
                onClose={onClose}
            />
        </>
    )
}

export const VerifyClientInsuranceAction: React.FC<OrderActionProps> = ({isValid}) => {

    const currentOrder = useAppState(state=>state.orders.currentItem)

    if (!currentOrder||!currentOrder.client) return null;

    return (
        <OrderProcessAction<DrawerActionProps<ClientFragment>>
            title={isValid?'Update Renter Insurance':'Set Renter Insurance'}
            action={VerifyInsuranceDrawer}
            icon={Icons.edit}
            props={{currentItem:currentOrder.client}}
            variant={isValid?"outline":"filled"}
            color={isValid?"gray":"blue"}
        />
    )
}